// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap_2fSAz","wrapBox":"index_wrapBox_1Wd2s","title":"index_title_225c2"};